import React, { useState, useEffect } from 'react';
import Header from '../../components/ui/Header';
import QuickActionMenu from '../../components/ui/QuickActionMenu';


const NordicMapDashboard = () => {
  const [activeAlert, setActiveAlert] = useState(null);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [activeCam, setActiveCam] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const trafficAlerts = [
  {
    id: 1,
    severity: 'red',
    label: 'KRIT',
    road: 'E6 Oslo–Gardermoen',
    title: 'Ulykke — ett felt stengt',
    desc: 'Personbilulykke i nordgående retning ved Grorud. Utrykningskjøretøy på stedet. Forvent 25–35 min forsinkelse.',
    delay: '~30 min',
    since: '08:47',
    img: "https://img.rocket.new/generatedImages/rocket_gen_img_108c958fe-1772187201378.png",
    alt: 'Norsk motorvei med kø og varsellys i vintervær'
  },
  {
    id: 2,
    severity: 'orange',
    label: 'ADVAR',
    road: 'Rv7 Hardangervidda',
    title: 'Snøstorm — kolonnekjøring',
    desc: 'Kraftig snøfall og sterk vind. Kolonnekjøring med ledsagerbil. Kjetting påbudt for tunge kjøretøy.',
    delay: '~45 min',
    since: '06:00',
    img: "https://img.rocket.new/generatedImages/rocket_gen_img_1633caf61-1772187200150.png",
    alt: 'Snødekt fjellvei over Hardangervidda i vinterstorm'
  },
  {
    id: 3,
    severity: 'yellow',
    label: 'INFO',
    road: 'E39 Bergen–Stavanger',
    title: 'Veiarbeid — redusert hastighet',
    desc: 'Asfaltering pågår mellom Stord og Fitjar. Hastigheten er redusert til 50 km/t. Arbeidet varer til 15. mars.',
    delay: '~10 min',
    since: '07:00',
    img: "https://img.rocket.new/generatedImages/rocket_gen_img_1bd893ace-1772187198733.png",
    alt: 'Veiarbeid med anleggsmaskiner langs norsk kystriksvei'
  },
  {
    id: 4,
    severity: 'blue',
    label: 'VÆR',
    road: 'E10 Lofoten',
    title: 'Glatt kjørebane — is',
    desc: 'Temperaturen falt til -8°C i natt. Veien er behandlet med salt, men lokale isflekker kan forekomme.',
    delay: 'Sakte fart',
    since: '05:30',
    img: "https://img.rocket.new/generatedImages/rocket_gen_img_1e834c4bb-1772187198983.png",
    alt: 'Isete vei i Lofoten med dramatisk fjellbakgrunn og nordlys'
  }];


  const cameras = [
  {
    id: 0,
    name: 'E6 Oslo Sentrum',
    status: 'LIVE',
    speed: '42 km/t',
    density: 'Tett',
    img: "https://img.rocket.new/generatedImages/rocket_gen_img_13ae3a12b-1772187199359.png",
    alt: 'Trafikkamera over Oslo sentrum med utsikt mot Operaen og Bjørvika'
  },
  {
    id: 1,
    name: 'E18 Lysaker',
    status: 'LIVE',
    speed: '28 km/t',
    density: 'Svært tett',
    img: "https://img.rocket.new/generatedImages/rocket_gen_img_17db0b54e-1772187201227.png",
    alt: 'Motorveikryss ved Lysaker med kø i rushtiden'
  },
  {
    id: 2,
    name: 'Rv7 Hønefoss',
    status: 'LIVE',
    speed: '78 km/t',
    density: 'Lett',
    img: "https://img.rocket.new/generatedImages/rocket_gen_img_10a553d3c-1772187199319.png",
    alt: 'Norsk riksvei gjennom snødekt fjordlandskap ved Hønefoss'
  }];


  const weatherCities = [
  { city: 'Oslo', temp: -2, cond: 'Snøbyger', icon: '❄️', wind: '8 m/s', road: 'Glatt' },
  { city: 'Bergen', temp: 4, cond: 'Regn', icon: '🌧️', wind: '14 m/s', road: 'Våt' },
  { city: 'Trondheim', temp: -5, cond: 'Klart', icon: '☀️', wind: '3 m/s', road: 'Tørr' },
  { city: 'Tromsø', temp: -9, cond: 'Snø', icon: '🌨️', wind: '11 m/s', road: 'Is' },
  { city: 'Stavanger', temp: 6, cond: 'Overskyet', icon: '☁️', wind: '9 m/s', road: 'Våt' }];


  const stats = [
  { label: 'Aktive meldinger', value: '47', unit: 'hendelser', color: '#e74c3c' },
  { label: 'Kameraer online', value: '1.284', unit: 'av 1.301', color: '#2EC4A0' },
  { label: 'Gjennomsnittsfart', value: '68', unit: 'km/t nasjonalt', color: '#F5A623' },
  { label: 'Veiarbeid pågår', value: '23', unit: 'strekninger', color: '#f39c12' }];


  const severityColors = {
    red: { bg: '#e74c3c', light: '#fdecea', border: '#e74c3c' },
    orange: { bg: '#e67e22', light: '#fef3e2', border: '#e67e22' },
    yellow: { bg: '#f39c12', light: '#fffde7', border: '#f39c12' },
    blue: { bg: '#2EC4A0', light: '#e8fdf8', border: '#2EC4A0' }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0a0e1a', color: '#f0f0f0', fontFamily: 'system-ui, sans-serif' }}>
      <Header />
      {/* HERO STRIP */}
      <div style={{ position: 'relative', height: 420, overflow: 'hidden' }}>
        <img
          src="https://images.unsplash.com/photo-1684698111574-abf70988c091"
          alt="Panoramautsikt over norsk fjordlandskap med snødekte fjell og serpentinvei"
          style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center 40%' }} />
        
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to right, rgba(10,14,26,0.92) 40%, rgba(10,14,26,0.4) 100%)' }} />
        <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', padding: '0 48px' }}>
          <div style={{ maxWidth: 600 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
              <div style={{ width: 10, height: 10, borderRadius: '50%', background: '#27ae60', animation: 'pulse 2s infinite', boxShadow: '0 0 0 4px rgba(39,174,96,0.3)' }} />
              <span style={{ fontSize: 11, letterSpacing: 3, textTransform: 'uppercase', color: '#27ae60', fontWeight: 700 }}>Sanntidsdata aktiv</span>
              <span style={{ fontSize: 11, color: '#888', marginLeft: 8 }}>{currentTime?.toLocaleTimeString('nb-NO')}</span>
            </div>
            <h1 style={{ fontSize: 'clamp(36px, 5vw, 64px)', fontWeight: 900, lineHeight: 1.05, margin: '0 0 16px', letterSpacing: -2 }}>
              Veikart
            </h1>
            <p style={{ fontSize: 18, color: '#aab', lineHeight: 1.6, margin: 0 }}>
              Sanntids trafikk og veimeldinger for hele Norge — oppdatert hvert 30. sekund fra Statens vegvesen.
            </p>
            <div style={{ display: 'flex', gap: 12, marginTop: 28, flexWrap: 'wrap' }}>
              {stats?.map((s, i) =>
              <div key={i} style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 8, padding: '10px 16px', backdropFilter: 'blur(8px)' }}>
                  <div style={{ fontSize: 22, fontWeight: 800, color: s?.color }}>{s?.value}</div>
                  <div style={{ fontSize: 10, color: '#888', textTransform: 'uppercase', letterSpacing: 1 }}>{s?.unit}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div style={{ maxWidth: 1400, margin: '0 auto', padding: '0 24px' }}>

        {/* LIVE TRAFFIC CAMERAS */}
        <section style={{ padding: '48px 0 0' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24 }}>
            <div style={{
              background: '#e74c3c',
              padding: '4px 12px',
              clipPath: 'polygon(0 0, calc(100% - 8px) 0, 100% 100%, 0 100%)'
            }}>
              <span style={{ fontSize: 10, fontWeight: 800, letterSpacing: 3, color: '#fff', textTransform: 'uppercase' }}>● LIVE</span>
            </div>
            <h2 style={{ fontSize: 28, fontWeight: 900, margin: 0, letterSpacing: -1, fontFamily: 'Impact, Haettenschweiler, sans-serif', textTransform: 'uppercase' }}>Trafikkameraer</h2>
            <div style={{ flex: 1, height: '2px', background: 'linear-gradient(90deg, rgba(231,76,60,0.4) 0%, transparent 100%)' }} />
            <span style={{ fontSize: 11, color: '#888', fontFamily: 'Inter, sans-serif' }}>{cameras?.length} kameraer aktive</span>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 3 }}>
            {/* Main camera */}
            <div
              style={{ gridColumn: '1 / 3', position: 'relative', cursor: 'pointer', overflow: 'hidden', borderRadius: '4px 0 0 4px' }}
              onClick={() => setActiveCam(activeCam === 0 ? 1 : 0)}>
              
              <img
                src={cameras?.[activeCam]?.img}
                alt={cameras?.[activeCam]?.alt}
                style={{ width: '100%', height: 340, objectFit: 'cover', display: 'block' }} />
              
              <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, transparent 50%)' }} />
              {/* Live badge — editorial */}
              <div style={{ position: 'absolute', top: 12, left: 12, display: 'flex', gap: 8, alignItems: 'center' }}>
                <span style={{ background: '#e74c3c', color: '#fff', fontSize: 10, fontWeight: 800, padding: '4px 10px', letterSpacing: 2, clipPath: 'polygon(0 0, calc(100% - 6px) 0, 100% 100%, 0 100%)' }}>● LIVE</span>
                <span style={{ background: 'rgba(0,0,0,0.6)', color: '#F5A623', fontSize: 10, fontWeight: 700, padding: '4px 10px', letterSpacing: 1, border: '1px solid rgba(245,166,35,0.3)' }}>{cameras?.[activeCam]?.name}</span>
              </div>
              <div style={{ position: 'absolute', bottom: 16, left: 16, right: 16 }}>
                {/* Speed indicator bar */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
                  <div style={{
                    background: 'rgba(0,0,0,0.7)',
                    border: '1px solid rgba(245,166,35,0.3)',
                    padding: '6px 14px',
                    display: 'flex', alignItems: 'center', gap: 8
                  }}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#F5A623" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                    <span style={{ fontSize: 13, fontWeight: 800, color: '#F5A623', fontFamily: 'Impact, sans-serif', letterSpacing: 1 }}>{cameras?.[activeCam]?.speed}</span>
                  </div>
                  <div style={{
                    background: 'rgba(0,0,0,0.7)',
                    border: '1px solid rgba(46,196,160,0.3)',
                    padding: '6px 14px',
                    display: 'flex', alignItems: 'center', gap: 8
                  }}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#2EC4A0" strokeWidth="2">
                      <rect x="3" y="3" width="18" height="18" rx="0" />
                      <line x1="3" y1="9" x2="21" y2="9" />
                      <line x1="3" y1="15" x2="21" y2="15" />
                      <line x1="9" y1="3" x2="9" y2="21" />
                      <line x1="15" y1="3" x2="15" y2="21" />
                    </svg>
                    <span style={{ fontSize: 11, fontWeight: 700, color: '#2EC4A0', letterSpacing: 1, textTransform: 'uppercase' }}>Tetthet: {cameras?.[activeCam]?.density}</span>
                  </div>
                </div>
                <div style={{ fontSize: 16, fontWeight: 800, fontFamily: 'Syne, sans-serif' }}>{cameras?.[activeCam]?.name}</div>
              </div>
            </div>
            {/* Side cameras */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              {cameras?.filter((_, i) => i !== activeCam)?.map((cam) =>
              <div
                key={cam?.id}
                style={{ position: 'relative', cursor: 'pointer', overflow: 'hidden', flex: 1, borderRadius: cam?.id === cameras?.[cameras?.length - 1]?.id ? '0 4px 4px 0' : '0' }}
                onClick={() => setActiveCam(cam?.id)}>
                
                  <img src={cam?.img} alt={cam?.alt} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                  <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.5)' }} />
                  <div style={{ position: 'absolute', top: 8, left: 8 }}>
                    <span style={{ fontSize: 8, fontWeight: 800, letterSpacing: 2, color: '#e74c3c', background: 'rgba(0,0,0,0.7)', padding: '2px 6px' }}>● LIVE</span>
                  </div>
                  <div style={{ position: 'absolute', bottom: 8, left: 10, right: 10 }}>
                    <div style={{ fontSize: 11, fontWeight: 700, fontFamily: 'Syne, sans-serif' }}>{cam?.name}</div>
                    <div style={{ fontSize: 10, color: '#F5A623', fontWeight: 600 }}>{cam?.speed}</div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* MAP + ALERTS SPLIT */}
        <section style={{ display: 'grid', gridTemplateColumns: '1fr 420px', gap: 24, padding: '48px 0 0', alignItems: 'start' }}>
          {/* Map */}
          <div>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 16, marginBottom: 20 }}>
              <h2 style={{ fontSize: 28, fontWeight: 800, margin: 0, letterSpacing: -1 }}>Interaktivt kart</h2>
            </div>
            <div style={{ position: 'relative', borderRadius: 8, overflow: 'hidden', border: '1px solid rgba(255,255,255,0.08)' }}>
              <iframe
                width="100%"
                height="520"
                loading="lazy"
                title="Norwegian Road Map"
                referrerPolicy="no-referrer-when-downgrade"
                src="https://www.google.com/maps?q=62.0,10.0&z=5&output=embed"
                style={{ display: 'block', border: 'none' }} />
              
              <div style={{ position: 'absolute', top: 12, right: 12, background: 'rgba(10,14,26,0.9)', border: '1px solid rgba(245,166,35,0.2)', borderRadius: 0, padding: '10px 14px', backdropFilter: 'blur(8px)' }}>
                <div style={{ fontSize: 9, color: '#F5A623', textTransform: 'uppercase', letterSpacing: 2, marginBottom: 8, fontWeight: 800 }}>Kartlag aktive</div>
                {['Trafikk', 'Kameraer', 'Veiarbeid', 'Vær']?.map((layer, i) =>
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                    <div style={{ width: 6, height: 6, background: ['#e74c3c', '#2EC4A0', '#f39c12', '#F5A623']?.[i] }} />
                    <span style={{ fontSize: 11, color: '#ccc' }}>{layer}</span>
                  </div>
                )}
              </div>
            </div>
            {/* Road condition strip */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 3, marginTop: 3 }}>
              {[
              { label: 'E6 Oslo–Trondheim', status: 'Delvis stengt', color: '#e74c3c', img: "https://img.rocket.new/generatedImages/rocket_gen_img_1fd34cdcd-1772187201602.png", alt: 'E6 motorvei med snø og kø' },
              { label: 'E18 Vestkorridoren', status: 'Tett trafikk', color: '#f39c12', img: "https://img.rocket.new/generatedImages/rocket_gen_img_1b0d66eed-1772187239526.png", alt: 'E18 vestkorridoren med rush-trafikk' },
              { label: 'E39 Kystveien', status: 'Veiarbeid', color: '#e67e22', img: "https://img.rocket.new/generatedImages/rocket_gen_img_1dc58aaad-1772187200092.png", alt: 'Veiarbeid langs E39 kystveien' },
              { label: 'Rv7 Hardanger', status: 'Kolonnekjøring', color: '#9b59b6', img: "https://img.rocket.new/generatedImages/rocket_gen_img_1f1a2b72d-1772187200500.png", alt: 'Snødekt Hardangervidda med kolonnekjøring' }]?.
              map((road, i) =>
              <div key={i} style={{ position: 'relative', overflow: 'hidden', borderRadius: i === 0 ? '0 0 0 8px' : i === 3 ? '0 0 8px 0' : 0, cursor: 'pointer' }}>
                  <img src={road?.img} alt={road?.alt} style={{ width: '100%', height: 90, objectFit: 'cover', display: 'block' }} />
                  <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, transparent 60%)' }} />
                  <div style={{ position: 'absolute', bottom: 6, left: 8, right: 8 }}>
                    <div style={{ fontSize: 10, fontWeight: 700, marginBottom: 2 }}>{road?.label}</div>
                    <div style={{ fontSize: 9, color: road?.color, fontWeight: 600 }}>{road?.status}</div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Alerts sidebar */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
              <h2 style={{ fontSize: 28, fontWeight: 800, margin: 0, letterSpacing: -1 }}>Meldinger</h2>
              <span style={{ fontSize: 11, color: '#888' }}>{trafficAlerts?.length} aktive</span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              {trafficAlerts?.map((alert) => {
                const sc = severityColors?.[alert?.severity];
                const isActive = activeAlert === alert?.id;
                return (
                  <div
                    key={alert?.id}
                    onClick={() => setActiveAlert(isActive ? null : alert?.id)}
                    style={{ cursor: 'pointer', border: `1px solid ${isActive ? sc?.bg : 'rgba(255,255,255,0.08)'}`, borderRadius: 6, overflow: 'hidden', transition: 'border-color 0.2s' }}>
                    
                    <div style={{ display: 'flex', gap: 0 }}>
                      <div style={{ width: 4, background: sc?.bg, flexShrink: 0 }} />
                      <div style={{ flex: 1, padding: '12px 14px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                          <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 2, color: sc?.bg, background: `${sc?.bg}22`, padding: '2px 6px', borderRadius: 3 }}>{alert?.label}</span>
                          <span style={{ fontSize: 11, color: '#888' }}>{alert?.road}</span>
                          <span style={{ fontSize: 10, color: '#666', marginLeft: 'auto' }}>{alert?.since}</span>
                        </div>
                        <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 4 }}>{alert?.title}</div>
                        {isActive &&
                        <>
                            <img src={alert?.img} alt={alert?.alt} style={{ width: '100%', height: 120, objectFit: 'cover', borderRadius: 4, margin: '8px 0' }} />
                            <p style={{ fontSize: 12, color: '#aaa', lineHeight: 1.6, margin: '0 0 8px' }}>{alert?.desc}</p>
                          </>
                        }
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <span style={{ fontSize: 11, color: sc?.bg, fontWeight: 600 }}>⏱ {alert?.delay}</span>
                          <span style={{ fontSize: 10, color: '#555', marginLeft: 'auto' }}>{isActive ? '▲ Skjul' : '▼ Detaljer'}</span>
                        </div>
                      </div>
                    </div>
                  </div>);

              })}
            </div>
          </div>
        </section>

        {/* WEATHER SECTION */}
        <section style={{ padding: '48px 0 0' }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 16, marginBottom: 24 }}>
            <h2 style={{ fontSize: 28, fontWeight: 800, margin: 0, letterSpacing: -1 }}>Vær og veiforhold</h2>
            <span style={{ fontSize: 12, color: '#888' }}>Oppdatert {currentTime?.toLocaleTimeString('nb-NO', { hour: '2-digit', minute: '2-digit' })}</span>
          </div>
          <div style={{ position: 'relative', borderRadius: 8, overflow: 'hidden', marginBottom: 3 }}>
            <img
              src="https://images.unsplash.com/photo-1712007919523-c81cc5a8af89"
              alt="Nordnorsk vinterlandskap med snødekte fjell, fjord og dramatisk himmel"
              style={{ width: '100%', height: 200, objectFit: 'cover', display: 'block', objectPosition: 'center 30%' }} />
            
            <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to right, rgba(10,14,26,0.9) 0%, rgba(10,14,26,0.5) 100%)' }} />
            <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', padding: '0 32px' }}>
              <div>
                <div style={{ fontSize: 12, color: '#888', textTransform: 'uppercase', letterSpacing: 2, marginBottom: 8 }}>Nasjonalt veivarsel</div>
                <div style={{ fontSize: 22, fontWeight: 800, marginBottom: 8 }}>Vinterkjøring — vær forberedt</div>
                <p style={{ fontSize: 13, color: '#aaa', maxWidth: 500, lineHeight: 1.6, margin: 0 }}>
                  Store deler av landet har snø og is på veiene. Bruk vinterdekk, kjør etter forholdene og hold god avstand til forankjørende.
                </p>
              </div>
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 3 }}>
            {weatherCities?.map((w, i) =>
            <div key={i} style={{ background: '#111827', border: '1px solid rgba(255,255,255,0.06)', borderRadius: i === 0 ? '0 0 0 8px' : i === 4 ? '0 0 8px 0' : 0, padding: '20px 16px' }}>
                <div style={{ fontSize: 28, marginBottom: 8 }}>{w?.icon}</div>
                <div style={{ fontSize: 16, fontWeight: 800, marginBottom: 2 }}>{w?.city}</div>
                <div style={{ fontSize: 28, fontWeight: 900, color: w?.temp < 0 ? '#74b9ff' : '#fdcb6e', marginBottom: 4 }}>{w?.temp}°</div>
                <div style={{ fontSize: 11, color: '#888', marginBottom: 8 }}>{w?.cond}</div>
                <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)', paddingTop: 8 }}>
                  <div style={{ fontSize: 10, color: '#666', marginBottom: 3 }}>Vind: {w?.wind}</div>
                  <div style={{ fontSize: 10, fontWeight: 700, color: w?.road === 'Is' || w?.road === 'Glatt' ? '#e74c3c' : w?.road === 'Våt' ? '#f39c12' : '#27ae60' }}>
                    Vei: {w?.road}
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>

        {/* CONSTRUCTION PHOTO CARDS */}
        <section style={{ padding: '48px 0 48px' }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 16, marginBottom: 24 }}>
            <h2 style={{ fontSize: 28, fontWeight: 800, margin: 0, letterSpacing: -1 }}>Pågående veiprosjekter</h2>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: 3 }}>
            {[
            {
              title: 'Oslofjordtunnelen — Rehabilitering',
              sub: 'E134 · Drammen–Kongsberg',
              desc: 'Norges lengste undersjøiske tunnel er stengt for full rehabilitering. Ny åpning planlagt høst 2026. Omkjøring via Rv23.',
              progress: 68,
              img: "https://images.unsplash.com/photo-1616427212135-36a7edd3e7e9",
              alt: 'Tunnelarbeid med anleggsmaskiner og arbeidere i sikkerhetsbekledning',
              tag: 'STENGT'
            },
            {
              title: 'E6 Trondheim — Ny firefelts',
              sub: 'Trondheim–Stjørdal',
              desc: 'Utbygging av firefelts motorvei. Ferdig 2027.',
              progress: 34,
              img: "https://img.rocket.new/generatedImages/rocket_gen_img_1b3727c58-1772187198878.png",
              alt: 'Motorveibygging med gravemaskin og betongarbeid i Trøndelag',
              tag: 'PÅGÅR'
            },
            {
              title: 'Rv4 Oslo — Utbedring',
              sub: 'Nittedal–Gjøvik',
              desc: 'Bredere kjørebane og nye tunneler.',
              progress: 51,
              img: "https://img.rocket.new/generatedImages/rocket_gen_img_10eb45539-1772187199575.png",
              alt: 'Veiutbedring med asfaltlegging og veimaskiner på norsk riksvei',
              tag: 'PÅGÅR'
            }]?.
            map((proj, i) =>
            <div key={i} style={{ position: 'relative', overflow: 'hidden', borderRadius: i === 0 ? '8px 0 0 8px' : i === 2 ? '0 8px 8px 0' : 0, cursor: 'pointer' }}>
                <img src={proj?.img} alt={proj?.alt} style={{ width: '100%', height: i === 0 ? 320 : 320, objectFit: 'cover', display: 'block' }} />
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to top, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.2) 60%, transparent 100%)' }} />
                <div style={{ position: 'absolute', top: 12, left: 12 }}>
                  <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 2, background: proj?.tag === 'STENGT' ? '#e74c3c' : '#f39c12', color: '#fff', padding: '3px 8px', borderRadius: 3 }}>{proj?.tag}</span>
                </div>
                <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: i === 0 ? '24px' : '16px' }}>
                  <div style={{ fontSize: 10, color: '#aaa', marginBottom: 4 }}>{proj?.sub}</div>
                  <div style={{ fontSize: i === 0 ? 18 : 14, fontWeight: 800, marginBottom: i === 0 ? 8 : 4 }}>{proj?.title}</div>
                  {i === 0 && <p style={{ fontSize: 12, color: '#bbb', lineHeight: 1.6, marginBottom: 12 }}>{proj?.desc}</p>}
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{ flex: 1, height: 3, background: 'rgba(255,255,255,0.15)', borderRadius: 2 }}>
                      <div style={{ width: `${proj?.progress}%`, height: '100%', background: '#27ae60', borderRadius: 2 }} />
                    </div>
                    <span style={{ fontSize: 11, fontWeight: 700, color: '#27ae60' }}>{proj?.progress}%</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>

      </div>
      <QuickActionMenu />
    </div>);

};

export default NordicMapDashboard;